var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.799,
    height: 106.799,
    viewBox: "0 0 106.799 106.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer-chip-1--computer-device-chip-electronics-cpu-microprocessor",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.43,3H11.061A8.061,8.061,0,0,0,3,11.061V59.43a8.061,8.061,0,0,0,8.061,8.061H59.43a8.061,8.061,0,0,0,8.061-8.061V11.061A8.061,8.061,0,0,0,59.43,3Z",
    transform: "translate(16.94 16.94)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5,20.654V.5",
    transform: "translate(31.276 -0.5)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9,20.654V.5",
    transform: "translate(59.522 -0.5)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.654,9H.5",
    transform: "translate(-0.5 59.522)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.654,5H.5",
    transform: "translate(-0.5 31.276)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9,11V31.154",
    transform: "translate(59.522 73.645)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5,11V31.154",
    transform: "translate(31.276 73.645)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11,5H31.154",
    transform: "translate(73.645 31.276)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11,9H31.154",
    transform: "translate(73.645 59.522)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.623,7.5H6.5",
    transform: "translate(37.934 44.669)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerChip);
export default __webpack_public_path__ + "static/media/computer-chip.8105a181952a06471e964058e5939cc1.svg";
export { ForwardRef as ReactComponent };